// Nav hydrate — desktop-only injection of mega-menu <template> content.
// Mobile parser NIE tworzy DOM z <template>.content, więc iOS Safari nie
// alokuje pamięci na 200+ crest img. Desktop viewport → hydratujemy.

function hydrateMegaMenus() {
  // Tylko desktop viewport
  if (!window.matchMedia('(min-width: 768px)').matches) return;

  const templates = document.querySelectorAll('[data-mega-tpl]');
  if (!templates.length) return;
  templates.forEach((tpl) => {
    if (!(tpl instanceof HTMLTemplateElement)) return;
    // Klon zawartości i wstaw po template (nie zastępujemy, żeby resize down->up nie odpalił dwa razy)
    tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
    tpl.remove();
  });
  // Po hydracji zawartość mega-menu (data-dm-drill / data-dm-sub / data-dm-items-for)
  // dopiero teraz istnieje w DOM — bindujemy jej click/hover handlery.
  if (typeof window.kbInitDesktopMega === 'function') {
    window.kbInitDesktopMega();
  }
}

if (typeof window !== 'undefined') {
  if (document.readyState !== 'loading') hydrateMegaMenus();
  else document.addEventListener('DOMContentLoaded', hydrateMegaMenus);

  // Resize handler — jeśli user zwiększy viewport z mobile do desktop, hydrate
  let lastMatched = window.matchMedia('(min-width: 768px)').matches;
  window.addEventListener('resize', () => {
    const now = window.matchMedia('(min-width: 768px)').matches;
    if (now && !lastMatched) hydrateMegaMenus();
    lastMatched = now;
  });
}

export {};
